<template>
  <v-app>
    <Navbar />
    <v-content class="white">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar";

export default {
  name: "App",

  components: {
    Navbar
  },
  data: function() {
    return {
      //mutePanicToNavbar: true
    };
  }
  // data: () => ({})
};
</script>
